import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import * as React from "react";
import { GetImmediateChildrenAsync } from "source/app/services/Workflows/GetImmediateChildren";
import { GetSortedNodesAsync } from "../RootNodeName/WorkflowsFloatingTools/SortNodes/SortNodes";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { IRenderChildNodesState } from "./IRenderChildNodesState";
import { DispatchEvent } from "source/app/services/Events/Events";
import { EEventType } from "source/app/services/Events/EEventType";
import { LogWorkflowNavigation } from "source/app/services/Workflows/WorkflowNavigationDiagnostics";

export async function LoadChildNodeData(
    rootNode: IWorkflowNode,
    visibleNodes: IWorkflowNode[],
    setState: React.Dispatch<React.SetStateAction<IRenderChildNodesState>>
) {
    LogWorkflowNavigation("LoadChildNodeData:queued", {
        rootNodeId: rootNode.id,
        visibleNodeCount: visibleNodes.length,
    });

    WithAnimatedProgressBarAsync(async () => {
        try {
            LogWorkflowNavigation("LoadChildNodeData:start", {
                rootNodeId: rootNode.id,
                visibleNodeCount: visibleNodes.length,
            });

            const immediateChildren = await GetImmediateChildrenAsync(
                rootNode,
                visibleNodes
            );

            if (immediateChildren.length > 0) {
                const sortedNodes = await GetSortedNodesAsync(
                    immediateChildren,
                    rootNode
                );

                setState((state) => ({
                    ...state,
                    immediateChildren,
                    sortedNodes,
                }));
            } else {
                setState((state) => ({
                    ...state,
                    immediateChildren,
                    sortedNodes: [],
                }));
            }
            LogWorkflowNavigation("LoadChildNodeData:finish", {
                rootNodeId: rootNode.id,
                immediateChildCount: immediateChildren.length,
            });
        } catch (e) {
            LogWorkflowNavigation("LoadChildNodeData:error", {
                rootNodeId: rootNode.id,
                error: GetErrorMessage(e),
            });
            throw e;
        } finally {
            LogWorkflowNavigation("LoadChildNodeData:dispatch-finish-loading", {
                rootNodeId: rootNode.id,
            });
            DispatchEvent(EEventType.Workflows_RootNodeChange_FinishLoading);
        }
    }, `LoadChildNodeData_${rootNode.id}`);
}

function GetErrorMessage(e: unknown) {
    return e instanceof Error ? e.message : String(e);
}
